import { useAppStore } from "../../shared/store/app";

/**
 * Whether the server is a read-only public demo (ADR-0045). Components read
 * the flag from the app store instead of plumbing it through the tree.
 *
 * @returns true when every write action must be hidden.
 */
export function useDemoMode(): boolean {
  return useAppStore((state) => state.demoMode);
}
